export default __webpack_public_path__ + "static/media/Brassard of the Katari.7dc6f113.jpg";